import { useQuery } from '@tanstack/react-query';
import { useApiClient } from './useApiClient';
import { useAuth } from '../contexts/AuthContext';
import toast from 'react-hot-toast';
import { type MasterCategoryType, MasterCategoryConst } from '../types/masterSearchTypes';

export interface MasterReferenceData {
    masters : any[]
}

const MASTER_URL_MAP: Record<MasterCategoryType, string> = {
  [MasterCategoryConst.SELLER]: 'sellers',
  [MasterCategoryConst.BUYER]: 'buyers',
  [MasterCategoryConst.FARMER]: 'farmers',
  [MasterCategoryConst.VARIETY]: 'varieties',
  [MasterCategoryConst.TEA_SEASON]: 'teaseasons',
  [MasterCategoryConst.TEA_TYPE]: 'teatypes',
  [MasterCategoryConst.GAP]: 'gaps',
  [MasterCategoryConst.NOTE]: 'notes',
  [MasterCategoryConst.BLOCK]: 'blocks',
  [MasterCategoryConst.JA]: 'jas',
  [MasterCategoryConst.AREA]: 'areas',
};

/**
 * マスターデータを取得するためのReact Queryフック
 */
export const useMasterReferenceQuery = (isLoggedIn: boolean, type : MasterCategoryType) => {
  const api = useApiClient();
  const { currentUser } = useAuth();

  return useQuery<MasterReferenceData, Error>({
    queryKey: ['masters_reference', type, currentUser?.loginId],

    queryFn: async () => {
      try {
        const path = MASTER_URL_MAP[type];
        if (!path) {
          throw new Error(`Unknown master type: ${type}`);
        }
        //全件取得
        const response = await api.get(`/masters/${path}/admin`);

        return {
          masters: response.data,
        };
      } catch (error) {
        console.error("Master fetch error:", error);
        toast.error("マスタデータの取得に失敗しました。");
        throw error;
      }
    },
    // ★★★ キャッシュ戦略の核心 ★★★
    // ログイン済み かつ typeに対応するパスが存在する場合のみ実行
    enabled: isLoggedIn && !!MASTER_URL_MAP[type],
    // // staleTimeをInfinityに設定すると、一度取得したデータは
    // // ユーザーがブラウザをリロードするまで「新鮮」と見なされ、再取得が走らなくなる
    // staleTimeを5分に設定。取得から5分間はデータを「新鮮」と見なし、
    // この間は画面を切り替えてもAPIの再実行は行われません。
    //staleTime: 1000 * 60 * 5, // 5分
    // gcTime (旧cacheTime) をInfinityに設定すると、非アクティブになってもキャッシュがメモリから消えなくなる
    //gcTime: Infinity,
    // エラー時に自動でリトライしない
    retry: false,
  });
};